import { classNames } from "../../helpers";

export default function DeleteIcon(props) {
  const { imageClassName } = props

  return (
    <svg className={classNames("text-white ", props.className)} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 22.5L15 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M21 22.5L21 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4.5 10.5H31.5V10.5C30.1022 10.5 29.4033 10.5 28.8519 10.7284C28.1169 11.0328 27.5328 11.6169 27.2284 12.3519C27 12.9033 27 13.6022 27 15V24C27 26.8284 27 28.2426 26.1213 29.1213C25.2426 30 23.8284 30 21 30H15C12.1716 30 10.7574 30 9.87868 29.1213C9 28.2426 9 26.8284 9 24V15C9 13.6022 9 12.9033 8.77164 12.3519C8.46716 11.6169 7.88313 11.0328 7.14805 10.7284C6.59674 10.5 5.89782 10.5 4.5 10.5V10.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M15.1022 5.05589C15.2731 4.89641 15.6498 4.75549 16.1737 4.65499C16.6976 4.55448 17.3396 4.5 18 4.5C18.6604 4.5 19.3024 4.55448 19.8263 4.65498C20.3502 4.75549 20.7269 4.89641 20.8978 5.05589" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
